/**
 * @generated SignedSource<<57b5b5e578358542a6cf52154605da1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetupScreenPollForTVQuery$variables = {
  id: string;
};
export type SetupScreenPollForTVQuery$data = {
  readonly dashboard: {
    readonly id: string;
    readonly name: string;
    readonly screens: ReadonlyArray<{
      readonly activeSession: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
    }>;
    readonly temporaryScreen: {
      readonly id: string;
    } | null;
  } | null;
};
export type SetupScreenPollForTVQuery = {
  response: SetupScreenPollForTVQuery$data;
  variables: SetupScreenPollForTVQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Dashboard",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "screens",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastSession",
            "kind": "LinkedField",
            "name": "activeSession",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "temporaryScreen",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetupScreenPollForTVQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetupScreenPollForTVQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "9df343b0b4deb51fffc38d230352edbe",
    "id": null,
    "metadata": {},
    "name": "SetupScreenPollForTVQuery",
    "operationKind": "query",
    "text": "query SetupScreenPollForTVQuery(\n  $id: ID!\n) {\n  dashboard(id: $id) {\n    id\n    name\n    screens {\n      id\n      name\n      activeSession {\n        id\n      }\n    }\n    temporaryScreen {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "62fa74f168ee4262cb45b5001fabb150";

export default node;
